__turbopack_context__.v({
  "wishlist-menu": "wishlist-menu-component-module-scss-module__5_oE1W__wishlist-menu",
  "wishlist-menu__list-button": "wishlist-menu-component-module-scss-module__5_oE1W__wishlist-menu__list-button",
  "wishlist-menu__list-button--selected": "wishlist-menu-component-module-scss-module__5_oE1W__wishlist-menu__list-button--selected",
  "wishlist-menu__list-create-button": "wishlist-menu-component-module-scss-module__5_oE1W__wishlist-menu__list-create-button",
  "wishlist-menu__list-names": "wishlist-menu-component-module-scss-module__5_oE1W__wishlist-menu__list-names",
});
